import AddInfo from './AddInfo/AddInfo.vue';
import BarChart from './BarChart/BarChart.vue';
import Button from './Button/Button.vue';
import Calendar from './Calendar/Calendar.vue';
import Checkbox from './Checkbox/Checkbox.vue';
import DisableAutocomplete from './DisableAutocomplete/DisableAutocomplete.vue';
import Dropdown from './Dropdown/Dropdown.vue';
import Footer from './Footer/Footer.vue';
import HeatmapChart from './HeatmapChart/HeatmapChart.vue';
import Input from './Input/Input.vue';
import LineChart from './LineChart/LineChart.vue';
import Link from './Link/Link.vue';
import Modal from './Modal/Modal.vue';
import PasswordInput from './PasswordInput/PasswordInput.vue';
import PhotoTab from './PhotoTab/PhotoTab.vue';
import PieChart from './PieChart/PieChart.vue';
import ShowSettings from './ShowSettings/ShowSettings.vue';
import Table from './Table/Table.vue';
import TableFeedback from './TableFeedback/TableFeedback.vue';
import Tabs from './Tabs/Tabs.vue';
import Title from './Title/Title.vue';
import TitleOptions from './TitleOptions/TitleOptions.vue';
import Toggle from './Toggle/Toggle.vue';

export default [
  AddInfo,
  BarChart,
  Button,
  Calendar,
  Checkbox,
  DisableAutocomplete,
  Dropdown,
  Footer,
  HeatmapChart,
  Input,
  LineChart,
  Link,
  Modal,
  PasswordInput,
  PhotoTab,
  PieChart,
  ShowSettings,
  Table,
  TableFeedback,
  Tabs,
  Title,
  TitleOptions,
  Toggle
];
